export default function nou(o) {
  return o === null || o === undefined;
}
